import { useState } from "react";
import classNames from "classnames";
import { Field } from "formik";
import { showPasswordIcon, hidePasswordIcon } from "../../assets/icons";
import Spinner, { SPINNER_NAMES } from "../../components/organisms/Spinner";

const { SET_PASSWORD } = SPINNER_NAMES;

const UpdatePassword = ({
  values,
  touched,
  errors,
  handleBlur,
  handleChange,
  isValid,
  dirty,
}) => {
  const [isSpinnerActive, setIsSpinnerActive] = useState(false);
  const [showNewPassword, setShouldShowNewPassword] = useState(false);
  const [showConfirmPassword, setShouldShowConfirmPassword] = useState(false);

  return (
    <div className="auth-body">
      <div className="form-group mb-6">
        <label className="text-sm font-medium mb-1 block">
          Your New Password
        </label>
        <div className="flex items-center bg-[#E8F0FE] focus-within:border-indigo-500 border-2 rounded-md">
          <Field
            autocomplete="new-password"
            className="form-control border-0 rounded-none !ring-0"
            type={showNewPassword ? "text" : "password"}
            name="newPassword"
            placeholder="Your New Password"
            value={values.newPassword}
            onBlur={handleBlur}
            onChange={handleChange}
          />
          <img
            className="w-8 h-4 cursor-pointer"
            src={showNewPassword ? showPasswordIcon : hidePasswordIcon}
            alt="Password"
            onClick={() => setShouldShowNewPassword(!showNewPassword)}
          />
        </div>
        {touched.newPassword && errors.newPassword && (
          <div
            className={classNames({
              "mb-9": errors.newPassword.length > 40,
            })}
          >
            <span className="font-medium text-red-500 text-sm absolute">
              {errors.newPassword}
            </span>
          </div>
        )}
      </div>
      <div className="form-group mb-6">
        <label className="text-sm font-medium mb-1 block">
          Confirm New Password
        </label>
        <div className="flex items-center bg-[#E8F0FE] focus-within:border-indigo-500 border-2 rounded-md">
          <Field
            className="form-control border-0 rounded-none !ring-0"
            type={showConfirmPassword ? "text" : "password"}
            name="confirmPassword"
            placeholder="Confirm New Password"
            value={values.confirmPassword}
            onBlur={handleBlur}
            onChange={handleChange}
          />
          <img
            className="w-8 h-4 cursor-pointer"
            src={showConfirmPassword ? showPasswordIcon : hidePasswordIcon}
            alt="Password"
            onClick={() => setShouldShowConfirmPassword(!showConfirmPassword)}
          />
        </div>
        {touched.confirmPassword && errors.confirmPassword && (
          <div className="font-medium text-red-500 text-sm absolute">
            {errors.confirmPassword}
          </div>
        )}
      </div>
      <button
        className="btn btn-primary block w-full text-center"
        type="submit"
        disabled={isSpinnerActive || !isValid || !dirty}
      >
        <Spinner
          name={SET_PASSWORD}
          setIsSpinnerActive={setIsSpinnerActive}
          persistSize
        >
          Set Password
        </Spinner>
      </button>
    </div>
  );
};

export default UpdatePassword;
